const getSidebarSelectedTab = (context) => {
	switch (context.activeView) {
		case "worldwide":
			return context.activeTabWorldwide;
		case "country":
			return context.activeTabCountries;
		case "region":
			return context.activeTabRegions;
		default:
			return 0;
	}
};

export default getSidebarSelectedTab;
